export default class DotBrush{
    constructor( color, strokeWeight, density=0.1 ){
        this.setColor(color);
        this.setStrokeWeight(strokeWeight);
        this.setDensity( density );
        console.log( "DotBrush constructor" );
    }

    static PEPE(){
        console.log( "PEPE");
    }

    setColor( color ){
        this.color = color;
    }
    setDensity( density ){
        this.density = density;
    }
    setStrokeWeight( strokeWeight ){
        this.strokeWeight = strokeWeight;
    }

    line( p0, p1 ){
        //console.log( "line: ", p0, p1 )
        stroke( this.color );
        strokeWeight( this.strokeWeight );

        
        let dist = gen.math.distance( p0, p1 );
        let numPoints = dist*this.density;
        let slices = gen.math.sliceLine( p0, p1, numPoints );
        //console.log( "numPoints: ", slices);
        for (let i = 0; i < slices.length; i++) {
            const slice = slices[i];
            circle( slice.x, slice.y, this.strokeWeight );
        }
        //line( p0.x, p0.y, p1.x, p1.y );
    }
}